var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoPaymentClearpayLoop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38 24",
    style: {
      enableBackground: "new 0 0 38 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4,6.8l-2.7-1.6L22,3.6c-1.8-1-4.1,0.3-4.1,2.4v0.4c0,0.2,0.1,0.4,0.3,0.5l1.3,0.7c0.4,0.2,0.8-0.1,0.8-0.5V6.3 c0-0.4,0.4-0.7,0.8-0.5l2.5,1.4L26,8.7c0.4,0.2,0.4,0.7,0,0.9L23.5,11L21,12.6c-0.4,0.2-0.8-0.1-0.8-0.5v-0.4c0-2.1-2.3-3.4-4.1-2.4 l-2.7,1.6l-2.7,1.6c-1.8,1-1.8,3.7,0,4.7l2.7,1.6l2.7,1.6c1.8,1,4.1-0.3,4.1-2.4v-0.4c0-0.2-0.1-0.4-0.3-0.5l-1.3-0.7 c-0.4-0.2-0.8,0.1-0.8,0.5v0.8c0,0.4-0.4,0.7-0.8,0.5l-2.5-1.4L12,15.3c-0.4-0.2-0.4-0.7,0-0.9l2.5-1.4l2.5-1.4 c0.4-0.2,0.8,0.1,0.8,0.5v0.4c0,2.1,2.3,3.4,4.1,2.4l2.7-1.6l2.7-1.6C29.2,10.5,29.2,7.9,27.4,6.8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPaymentClearpayLoop);
export default __webpack_public_path__ + "static/media/logo-payment-clearpay-loop.5c158313.svg";
export { ForwardRef as ReactComponent };